import WebUtils from "../components/utils/WebUtils";

let baseUrl = WebUtils.getAiInterviewBaseUrl();
let aiInterviewBaseUrl = `${baseUrl}/interview-platform/api/v1`;

export const getInterviewDataApi = `${aiInterviewBaseUrl}/interview/getBasicInfo`;
export const getInterviewConfigApi = `${aiInterviewBaseUrl}/interview/getConfiguration`;
export const joiningValidateApi = `${aiInterviewBaseUrl}/login/interview`;
export const previewLogApi = `${aiInterviewBaseUrl}/interview/logSessionData`;
export const uploadSnapshotApi = `${aiInterviewBaseUrl}/interview/upload/snapshot`;
export const uploadScreenshotApi = `${aiInterviewBaseUrl}/interview/upload/screenshot`;
export const uploadCandVideoApi = `${aiInterviewBaseUrl}/interview/upload/candidateVideo`;
export const uploadCandScreenApi = `${aiInterviewBaseUrl}/interview/upload/video`;
export const candVideoRejoinApi = `${aiInterviewBaseUrl}/interview/upload/candidateVideoRejoin`;
export const candScreenRejoinApi = `${aiInterviewBaseUrl}/interview/upload/screenVideoRejoin`;
export const completionInterviewGetApi = `${aiInterviewBaseUrl}/interview/getInterviewCompletionData`;
export const feedbackPostApi = `${aiInterviewBaseUrl}/interview/candidateReview`;
export const reportGetApi = `${aiInterviewBaseUrl}/report/twoWay/get`;
export const reportGetShotImgApi = `${aiInterviewBaseUrl}/report/twoWay/getImageData`;
export const reportValidatePostApi = `${aiInterviewBaseUrl}/report/validate`;
export const reportActionItemPostApi = `${aiInterviewBaseUrl}/report/twoWay/editActionableItems`;
export const reportOverallAnalysPostApi = `${aiInterviewBaseUrl}/report/twoWay/editOverallAnalysis`;
export const reportSkillPostApi = `${aiInterviewBaseUrl}/report/twoWay/editSkillAnalysis`;
export const reportViewCountPostApi = `${aiInterviewBaseUrl}/report/twoWay/updateReportViewCount`;
export const reportDownloadCountPostApi = `${aiInterviewBaseUrl}/report/twoWay/updateReportDownloadCount`;
export const interviewAnalysisGetAPi = `${aiInterviewBaseUrl}/report/twoWay/getInterviewVideoInfo`;
export const interviewAnalysisConfigurationGetAPi = `${aiInterviewBaseUrl}/report/twoWay/getBasicInfo`;
export const interviewAnalysisCountAPi = `${aiInterviewBaseUrl}/report/twoWay/updateReportVideoRecordingViewCount`;
export const getConversationHistoryApi = `${aiInterviewBaseUrl}/interview/twoWay/getConversationHistory`;
export const interviewAnalyticsTimingGetAPi = `${aiInterviewBaseUrl}/report/twoWay/jd/getInterviewAnalyticsTimings`;

export const getTranscriptDataApi = `${aiInterviewBaseUrl}/report/twoWay/getTranscriptData`;
export const updateTranscriptViewCountApi = `${aiInterviewBaseUrl}/report/twoWay/updateReportTranscriptViewCount`;

export const getBotConfigurationApi = `${aiInterviewBaseUrl}/interview/twoWay/getBotConfiguration`;
export const updateConversationHistoryApi = `${aiInterviewBaseUrl}/interview/twoWay/updateHistory`;
export const addUserThinkingTimeApi = `${aiInterviewBaseUrl}/interview/twoWay/addInterviewThinkingTiming`;
export const addUserAnsweringTimeApi = `${aiInterviewBaseUrl}/interview/twoWay/addInterviewAnswerTiming`;
export const updateAudioAnomalyApi = `${aiInterviewBaseUrl}/interview/twoWay/updateAudioAnomaly`;
export const addMonitoringToolDataApi = `${aiInterviewBaseUrl}/interview/twoWay/addMonitoringToolData`;
export const endInterviewApi = `${aiInterviewBaseUrl}/report/twoWay/generate`;

export const interviewDemoSchedule = `${aiInterviewBaseUrl}/internal/twoWay/interview/initialize`;

export const interviewDemoGetUrl = `${aiInterviewBaseUrl}/internal/twoWay/interview/getUrlInfo`;
export const reportDemoGetUrl = `${aiInterviewBaseUrl}/internal/twoWay/report/getUrlInfo`;

export const uploadSnapShotFruad = `${aiInterviewBaseUrl}/interview/twoWay/uploadFraudulentSnapshot`;
export const getSusAppsApi = `${aiInterviewBaseUrl}/interview/twoWay/getSuspiciousApp`;

